<div (click)="$event.stopPropagation()" #notificationIcon class="me-2" *ngIf="userProfile">
    <button type="button" (click)="openNotification()" aria-label="Notifications"
        class="icon-btn d-flex align-items-center justify-content-center position-relative">
        <mat-icon aria-hidden="true"
            [matBadge]="notificationData?.unreadNotificationCount"
            [matBadgeHidden]="!notificationData || notificationData.unreadNotificationCount === 0"
            matBadgeColor="warn" matBadgeSize="small">notifications</mat-icon>
    </button>
</div>
